import React, { useState } from 'react';
// import Rating from 'mui';
import PropTypes from 'prop-types';
import Rating from '@material-ui/lab/Rating';
import { Flex } from 'UIKit/Grid';
import Star from '@/assets/img/Star.png';
import Void from '@/assets/img/VoidStar.png';
import StatusButton from '../UIKit/Buttons/StatusButton';
import RenderCustomTextarea from '../Form/Input/RenderCustomTextarea';

export default function Rate({ name, onRate }) {
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState('');
  const [check, setCheck] = useState(false);
  const [rated, setRated] = useState(false);

  function handleRate() {
    onRate({ stars, comment });
    setRated(true);
  }

  return check ? (
    <Flex flexDirection="column" alignItems="center" style={{ gap: 10 }}>
      <Rating
        name={name}
        value={stars}
        disabled={rated}
        onChange={(e, v) => setStars(v)}
        icon={<img src={Star} alt="" />}
        emptyIcon={<img src={Void} alt="" />}
      />
      {rated ? (
        comment
      ) : (
        <>
          <RenderCustomTextarea
            input={{
              value: comment,
              onChange: e => setComment(e.target.value),
            }}
            meta={{}}
          />
          <StatusButton status="check" onClick={handleRate} />
        </>
      )}
    </Flex>
  ) : (
    <StatusButton status="check" onClick={() => setCheck(true)} />
  );
}

Rate.propTypes = {
  name: PropTypes.string.isRequired,
  onRate: PropTypes.func.isRequired,
};
